import React from "react";
import { useTracking } from "react-tracking";
import { useDispatch, useSelector } from "react-redux";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";
import EndUserPreferencesRoutes from "./EndUserPreferencesRoutes";

const EndUserPreferencesScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Administration Users Preferences",
      page: "Admin Users Preferences",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {

        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );

  return (
    <div>
      <Track>
        <EndUserPreferencesRoutes />
      </Track>
    </div>
  );
};

export default EndUserPreferencesScreen;
